export default "__VITE_ASSET__CedRDx51__"